export default function Footer () {
  return (
    <footer className="footer footer-alt">
            {`© Z Software ${new Date().getFullYear()}. All other trademarks and copyright all reserved. `}
    </footer>
  );
}
